import { render, staticRenderFns } from "./WebLinkTypeSelect.vue?vue&type=template&id=08d4bd17&scoped=true&lang=pug"
import script from "./WebLinkTypeSelect.vue?vue&type=script&lang=js"
export * from "./WebLinkTypeSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d4bd17",
  null
  
)

export default component.exports